import React from 'react';
import { Link } from 'react-router-dom';
import HeroSection from '../components/HeroSection';
import SectionTitle from '../components/SectionTitle';
import FeatureCard from '../components/FeatureCard';
import { GlobeIcon, UsersIcon, AwardIcon, MapPinIcon } from 'lucide-react';
const AboutPage = () => {
  const aboutSections = [{
    id: 'company',
    title: '企业介绍',
    description: '了解我们的企业历程、愿景和使命',
    icon: <GlobeIcon className="h-12 w-12" data-id="element-288" />
  }, {
    id: 'team',
    title: '团队介绍',
    description: '认识我们的专业团队，了解他们的专长和经验',
    icon: <UsersIcon className="h-12 w-12" data-id="element-289" />
  }, {
    id: 'culture',
    title: '企业文化',
    description: '探索我们的核心价值观和企业文化',
    icon: <AwardIcon className="h-12 w-12" data-id="element-290" />
  }, {
    id: 'certificates',
    title: '资质证书',
    description: '查看我们的专业资质和认证',
    icon: <AwardIcon className="h-12 w-12" data-id="element-291" />
  }, {
    id: 'join',
    title: '加入我们',
    description: '探索激动人心的职业机会，成为我们团队的一员',
    icon: <UsersIcon className="h-12 w-12" data-id="element-292" />
  }, {
    id: 'contact',
    title: '联系我们',
    description: '获取我们的联系方式，随时与我们沟通',
    icon: <MapPinIcon className="h-12 w-12" data-id="element-293" />
  }];
  const offices = [{
    city: '青岛总部',
    address: '青岛市崂山区科技创新园12号楼',
    phone: '+86-532-12345678',
    email: 'qingdao@aitech.com',
    image: 'https://images.unsplash.com/photo-1566159196870-3f042aa3ecb4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  }, {
    city: '北京办公室',
    address: '北京市海淀区中关村大街1号',
    phone: '+86-10-12345678',
    email: 'beijing@aitech.com',
    image: 'https://images.unsplash.com/photo-1599571234909-29ed5d1321d6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  }, {
    city: '上海办公室',
    address: '上海市浦东新区张江高科技园区',
    phone: '+86-21-12345678',
    email: 'shanghai@aitech.com',
    image: 'https://images.unsplash.com/photo-1538428494232-9c0d8a3ab403?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  }, {
    city: '成都办公室',
    address: '成都市高新区天府软件园',
    phone: '+86-28-12345678',
    email: 'chengdu@aitech.com',
    image: 'https://images.unsplash.com/photo-1545393870-10dc4dae231f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  }, {
    city: '多伦多办公室',
    address: '多伦多市科技创新区25号',
    phone: '+1-416-1234567',
    email: 'toronto@aitech.com',
    image: 'https://images.unsplash.com/photo-1517090504586-fde19ea6066f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  }];
  return <div className="bg-white" data-id="element-294">
      <HeroSection title="关于我们" subtitle="专注AI技术创新与应用，致力于为企业提供领先的人工智能解决方案" backgroundImage="https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80" size="medium" data-id="element-295" />
      <section className="py-16 md:py-24" data-id="element-296">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-297">
          <SectionTitle title="了解我们" subtitle="探索我们的企业信息、团队和文化" data-id="element-298" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-299">
            {aboutSections.map(section => <FeatureCard key={section.id} title={section.title} description={section.description} icon={section.icon} variant="bordered" link={`/about/${section.id}`} data-id="element-300" />)}
          </div>
        </div>
      </section>
      <section className="py-16 md:py-24 bg-gray-50" data-id="element-301">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-302">
          <SectionTitle title="企业简介" subtitle="专注AI技术创新，赋能行业数字化转型" data-id="element-303" />
          <div className="flex flex-col md:flex-row gap-12 items-center" data-id="element-304">
            <div className="w-full md:w-1/2" data-id="element-305">
              <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="企业简介" className="w-full h-auto rounded-lg shadow-lg" data-id="element-306" />
            </div>
            <div className="w-full md:w-1/2" data-id="element-307">
              <p className="text-lg text-gray-700 mb-6" data-id="element-308">
                我们是一家专注于人工智能技术创新与应用的高新技术企业，成立于2018年，总部位于青岛，在北京、上海、成都和多伦多设有分支机构。
              </p>
              <p className="text-lg text-gray-700 mb-6" data-id="element-309">
                公司拥有一支由顶尖高校和科技企业专家组成的研发团队，核心成员来自清华、北大、中科院等知名高校和Google、微软、百度等知名企业，在人工智能领域拥有深厚的技术积累和丰富的行业经验。
              </p>
              <p className="text-lg text-gray-700 mb-6" data-id="element-310">
                我们的产品和服务覆盖大模型服务平台、异构算力服务和智能解决方案等多个领域，致力于为金融、医疗、制造、政企等行业客户提供高质量的AI技术支持，助力企业数字化转型和智能化升级。
              </p>
              <div className="mt-8" data-id="element-311">
                <Link to="/about/company" className="inline-block bg-primary-600 hover:bg-primary-700 text-white font-medium py-2 px-6 rounded-md transition duration-300" data-id="element-312">
                  了解更多
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16 md:py-24" data-id="element-313">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-314">
          <SectionTitle title="我们的办公地点" subtitle="全球多地办公，为客户提供便捷服务" data-id="element-315" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-316">
            {offices.map((office, index) => <div key={index} className="bg-white rounded-lg overflow-hidden shadow-md transition-transform duration-300 hover:shadow-lg hover:-translate-y-1" data-id="element-317">
                <div className="h-48 overflow-hidden" data-id="element-318">
                  <img src={office.image} alt={office.city} className="w-full h-full object-cover" data-id="element-319" />
                </div>
                <div className="p-6" data-id="element-320">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-321">
                    {office.city}
                  </h3>
                  <div className="space-y-2 text-gray-600" data-id="element-322">
                    <p className="flex items-start" data-id="element-323">
                      <MapPinIcon className="h-5 w-5 text-primary-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-324" />
                      <span data-id="element-325">{office.address}</span>
                    </p>
                    <p className="flex items-center" data-id="element-326">
                      <svg className="h-5 w-5 text-primary-500 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-327">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" data-id="element-328" />
                      </svg>
                      <span data-id="element-329">{office.phone}</span>
                    </p>
                    <p className="flex items-center" data-id="element-330">
                      <svg className="h-5 w-5 text-primary-500 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-331">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" data-id="element-332" />
                      </svg>
                      <span data-id="element-333">{office.email}</span>
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>
      <section className="py-16 md:py-24 bg-primary-600" data-id="element-334">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-335">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-336">
            加入我们，共创AI未来
          </h2>
          <p className="text-xl text-white opacity-90 mb-8 max-w-3xl mx-auto" data-id="element-337">
            我们始终在寻找优秀的人才加入团队。如果您对AI技术充满热情，欢迎加入我们，一起探索AI的无限可能。
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-338">
            <Link to="/about/join" className="inline-block bg-white text-primary-600 font-medium py-3 px-8 rounded-md transition duration-300 hover:bg-gray-100" data-id="element-339">
              查看职位
            </Link>
            <Link to="/about/contact" className="inline-block bg-transparent text-white font-medium py-3 px-8 rounded-md border border-white transition duration-300 hover:bg-white/10" data-id="element-340">
              联系我们
            </Link>
          </div>
        </div>
      </section>
    </div>;
};
export default AboutPage;